import { render, staticRenderFns } from "./AffiliatesLegalFtc.vue?vue&type=template&id=0d1194be&"
import script from "./AffiliatesLegalFtc.vue?vue&type=script&lang=js&"
export * from "./AffiliatesLegalFtc.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesLegalFtc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1194be')) {
      api.createRecord('0d1194be', component.options)
    } else {
      api.reload('0d1194be', component.options)
    }
    module.hot.accept("./AffiliatesLegalFtc.vue?vue&type=template&id=0d1194be&", function () {
      api.rerender('0d1194be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesLegalFtc.vue"
export default component.exports